/**
 * This enum represents the possible valid values for sorting in the Open Item Modal.
 */
export var OpenItemModalSortColumn;
(function (OpenItemModalSortColumn) {
    OpenItemModalSortColumn["NAME"] = "name";
    OpenItemModalSortColumn["MODIFY_DATE_OBJ"] = "modifyDateObj";
})(OpenItemModalSortColumn || (OpenItemModalSortColumn = {}));
